<div class="row mb-2 mt-2 me-0">
  @if (showLinks()) {
    <div class="me-auto col">
      <app-rota-page-switch [weekId]="currentWeek.id" [isActiveRotaPage]="true"></app-rota-page-switch>
    </div>
  }
  <div class="m-auto text-center col">
    @if (showLinks()) {
      <a [ngClass]="{'link-disabled': !previousWeek}"
        routerLink="/rota-week/{{previousWeek?.id}}"
      class="btn btn-primary btn-sm me-2"><</a>
    }
    <div class="week-with-date">
      <span class="week-number">Week {{ currentWeek.from | dateParse | dateFormat: 'WW' }}</span>
      <span class="week-start">{{ currentWeek.from | dateParse | dateFormat: 'ddd, D MMM YYYY' }}</span> -
      <span class="week-end">{{ currentWeek.to | dateParse | dateFormat: 'ddd, D MMM YYYY'}}</span>
    </div>
    @if (showLinks()) {
      <a [ngClass]="{'link-disabled': !nextWeek}"
        routerLink="/rota-week/{{nextWeek?.id}}"
      class="btn btn-primary btn-sm ms-2">></a>
    }
  </div>
  @if (showLinks()) {
    <div class="ms-auto col">
      <div class="float-end">
        @for (weekday of weekdays; track weekday) {
          <a (click)="navigateToDay(weekday)" class="weekday-link">
            {{ weekday | dayOfWeekParse }}
          </a>
        }
      </div>
      <br>
        <ul class="legend p-0 m-0">
          <li><span class="over-staffed"></span> Overcapacity</li>
          <li><span class="under-staffed"></span> Undercapacity</li>
        </ul>
      </div>
    }
  </div>